import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
  import useIcons from '@/composables/useIcons'
  import { UserModule } from '@/store/modules/user'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import ThemeApi from '@/services/api/ThemeApi'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import CookieHelper from '@/helpers/CookieHelper'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useAuthentication from '@/composables/useAuthentication'
  import type { CompanyTheme } from '@/services/interfaces/Theme'
  import type { Company } from '@/services/interfaces/Auth0'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySelection',
  setup(__props) {

  const { redirectToNewDomain, setIsLoadingComponentViewData } = useCommonMixin()
  const { redirect, companyKey } = useAuthentication()
  const { arrowRight } = useIcons()
  const companyThemes = ref([] as CompanyTheme[])

  const firstName = computed(() => UserModule.firstName)

  const companies = computed(() => UserModule.companies)

  const loadingCompanyThemes = computed(() => !companyThemes.value.length)

  const companyTheme = (index: number) => {
    if (
      companyThemes.value[index].colorVariants.heroBackgroundColor &&
      companyThemes.value[index].colorVariants.heroForegroundColor
    ) {
      return {
        'background-color':
          companyThemes.value[index].colorVariants.heroBackgroundColor || 'var(--hero-background-color)',
        color: companyThemes.value[index].colorVariants.heroForegroundColor || 'var(--hero-foreground-color)',
      }
    }
    return null
  }
  const setUserCompany = (company: Company) => {
    CookieHelper.removeCrossDomainCookie('logoUrl')
    CookieHelper.setCrossDomainCookie(companyKey.value, company.id)
    if (['production', 'qa'].includes(process.env.APP_ENV!)) {
      return redirectToNewDomain(company.subDomain, redirect.value)
    }
    window.location.href = redirect.value
  }

  const setCompanyPromisedThemes = () => {
    const promisedThemes = companies.value.map((company) => ThemeApi.getTheme(company.id))
    Promise.all(promisedThemes).then((themes) => {
      companyThemes.value = themes
    })
  }

  watch(loadingCompanyThemes, (value) => {
    if (value) {
      setIsLoadingComponentViewData(true)
    } else {
      setIsLoadingComponentViewData(false)
    }
  })

  onMounted(() => {
    setCompanyPromisedThemes()
  })

return { __sfc: true,redirectToNewDomain, setIsLoadingComponentViewData, redirect, companyKey, arrowRight, companyThemes, firstName, companies, loadingCompanyThemes, companyTheme, setUserCompany, setCompanyPromisedThemes, computed, onMounted, ref, watch, useIcons, UserModule, SVGRenderer, ThemeApi, LoadingSpinner, CookieHelper, useCommonMixin, useAuthentication }
}

})